import React, { FC } from 'react';
import { Icon, Box, Button, ButtonAppearance, ButtonSize, Text } from '@bechtel/gds';
import { CommodityMilestone, CommodityType, MaterialCommodity } from '@bechtel/types';
import { useWorkPackage } from '~/detail/context';
import { useWorkPackagePermissions } from '~/hooks/use-work-package-permissions';
import { CommodityBulkActions } from '~/detail/commodities/multiple-action';
import { Trans } from '@lingui/macro';

interface CommodityStatusActionsProps {
  commodities: MaterialCommodity[];
  milestones: CommodityMilestone[];
  setCollapseAll: () => void;
  collapseAll?: boolean;
  commodityType: CommodityType;
  // togglePendingApprovals: () => void;
  // pendingApprovalsFlag: boolean;
}

export const CommodityStatusActions: FC<CommodityStatusActionsProps> = ({
  commodities,
  milestones,
  setCollapseAll,
  commodityType,
  collapseAll = false,
  // togglePendingApprovals,
  // pendingApprovalsFlag,
}) => {
  const { assignedCrewMembers } = useWorkPackage();
  const { canClaimMilestone, canApproveMilestone } = useWorkPackagePermissions(assignedCrewMembers);
  // FIXME: utilizing .name is brittle here since it is DB driven
  const hideBulkButton = !(canClaimMilestone || canApproveMilestone) || commodityType.name === 'Weld';

  return (
    <Box
      justifyContent={{ sm: 'flex-end' }}
      alignItems={{ sm: 'center' }}
      css={{ position: 'relative' }}
      data-testid="commodity-status-actions"
    >
      <Box mr={{ sm: '300' }} flexShrink={{ sm: '0' }}>
        <Button appearance={ButtonAppearance.SECONDARY} size={ButtonSize.SMALL} onClick={() => setCollapseAll()}>
          <Box mr={{ sm: '300' }}>
            <Icon icon="compress-arrows-alt" fillColor="blue.800" />
          </Box>
          <Text size="300" color="grey.1000">
            {collapseAll ? <Trans>Expand All</Trans> : <Trans>Collapse All</Trans>}
          </Text>
        </Button>
      </Box>

      {!hideBulkButton && milestones && milestones.length > 0 && (
        <CommodityBulkActions commodities={commodities} commodityType={commodityType}></CommodityBulkActions>
      )}
    </Box>
  );
};
